module.exports = __webpack_public_path__ + "static/img/celoscope-detail-19.6664f95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-detail-19.jpg
// module id = bQ8D
// module chunks = 51